import { createSlice } from '@reduxjs/toolkit';
import { AdminSearchTypes } from 'src/components/ToggleBox/ToggleBox.types';
import { SortTypes } from 'src/screens/admins/AdminsScreen.types';

import { InitialAdminsStateType } from '../types/adminsTypes';

const name = 'admins';

const INITIAL_STATE: InitialAdminsStateType = {
  admins: [],
  filteredAdmins: [],
  isAdminsLoading: false,
  isFilteredAdminsLoading: false,
  selectedToggleBoxValue: AdminSearchTypes.NAME,
  sortByValue: SortTypes.NAME,
  searchInputValue: '',
  searchParams: null,
  error: null,

  isAddRequestLoading: false,
  isInviteRequestLoading: false,
  isUpdateRequestLoading: false,
  isRemoveRequestLoading: false,
  isActivateRequestLoading: false,
};

const adminsSlice = createSlice({
  name,
  initialState: INITIAL_STATE,
  reducers: {
    updateSearchParams: (state, action) => {
      const { selectedToggleBox, searchInput, sortBy } = action.payload;
      state.selectedToggleBoxValue = selectedToggleBox;
      state.searchInputValue = searchInput;
      state.sortByValue = sortBy;
    },

    getAdmins: state => {
      state.isAdminsLoading = true;
    },
    getAdminsSuccess: (state, action) => {
      state.isAdminsLoading = false;
      state.admins = action.payload;
    },
    getAdminsFailure: (state, action) => {
      state.isAdminsLoading = false;
      state.error = action.payload;
    },

    getFilteredAdmins: (state, action) => {
      state.isFilteredAdminsLoading = true;
      state.searchParams = action.payload;
    },
    getFilteredAdminsSuccess: (state, action) => {
      state.isFilteredAdminsLoading = false;
      state.filteredAdmins = action.payload;
    },
    getFilteredAdminsFailure: (state, action) => {
      state.isFilteredAdminsLoading = false;
      state.error = action.payload;
    },

    addAdmin: (state, action) => {
      state.isAddRequestLoading = true;
    },
    addAdminSuccess: state => {
      state.isAddRequestLoading = false;
    },
    addAdminFailure: (state, action) => {
      state.isAddRequestLoading = false;
      state.error = action.payload;
    },

    inviteAdmin: (state, action) => {
      state.isInviteRequestLoading = true;
    },
    inviteAdminSuccess: state => {
      state.isInviteRequestLoading = false;
    },
    inviteAdminFailure: (state, action) => {
      state.isInviteRequestLoading = false;
      state.error = action.payload;
    },

    updateAdmin: (state, action) => {
      state.isUpdateRequestLoading = true;
    },
    updateAdminSuccess: state => {
      state.isUpdateRequestLoading = false;
    },
    updateAdminFailure: (state, action) => {
      state.isUpdateRequestLoading = false;
      state.error = action.payload;
    },

    removeAdmin: (state, action) => {
      state.isRemoveRequestLoading = true;
    },
    removeAdminSuccess: state => {
      state.isRemoveRequestLoading = false;
    },
    removeAdminFailure: (state, action) => {
      state.isRemoveRequestLoading = false;
      state.error = action.payload;
    },

    activateAdmin: (state, action) => {
      state.isActivateRequestLoading = true;
    },
    activateAdminSuccess: state => {
      state.isActivateRequestLoading = false;
    },
    activateAdminFailure: (state, action) => {
      state.isActivateRequestLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  updateSearchParams,

  getFilteredAdmins,
  getFilteredAdminsSuccess,
  getFilteredAdminsFailure,

  getAdmins,
  getAdminsSuccess,
  getAdminsFailure,

  addAdmin,
  addAdminSuccess,
  addAdminFailure,

  inviteAdmin,
  inviteAdminSuccess,
  inviteAdminFailure,

  updateAdmin,
  updateAdminSuccess,
  updateAdminFailure,

  removeAdmin,
  removeAdminSuccess,
  removeAdminFailure,

  activateAdmin,
  activateAdminSuccess,
  activateAdminFailure,
} = adminsSlice.actions;

export default adminsSlice.reducer;
